export default __webpack_public_path__ + "static/media/sugarcane.5e031a21.jpg";